import React from 'react';
import Landing_Section_1 from '../../images/shopify-popup/landing-section-1.png'

class SectionOne extends React.Component {
  render() {
    return (
      <div className="main-container">
        <section className="cover unpad--bottom switchable switchable--switch bg-shopify-popup-section-1 text-center-xs">
          <div className="container">
            <div className="row align-items-center justify-content-around shopify-popup-pading">
              <div className="ol-md-6 col-lg-5 mt-0 ">
                <h1>Convert visitors into customers in 2 minutes with stunning Shopify popups</h1>
                <p className="lead landingP">
                Popupfox is fully compatible with Shopify stores. Sign up for Popupfox right away and start designing the
                 best-fitting Sohipy popup for your store! Besides, it’s free!
                </p>
                <a
                  id="landing--try-now--section1-link"
                  className="btn btn--primary type--uppercase"
                  href="https://dashboard.popupfox.com/register" >
                  <span className="btn__text">TRY NOW</span>
                </a>
              </div>
              <div className="col-md-6">
                <img src={Landing_Section_1} alt="Image" />
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default SectionOne;